import React from 'react'
import { NlpExample } from '@feedyou-ai/feedbot-schema'

import { feedbotToast } from '../../lib/feedbotToast'

export function toastNotifyProcessUtteranceError(utterance: NlpExample) {
  const id = 'process-utterance-error'
  const title = 'Processing failed'
  const content = `Failed to process utterance ${utterance} 😕`

  feedbotToast.error({ id, title, content })
}
